module.exports = __webpack_public_path__ + "img/list-title-a.c612a7aa.png";